import { Button } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon, PrinterIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useKPIQuery } from "../api/queries";
import { KPIPdfPreviewContent } from "../ui/KPIPdfPreviewContent";

export function KPIPdfPreviewPage() {
  const { id } = useParams({ from: "/app/kpi/$id/pdf-preview" });
  const nav = useNavigate({ from: "/app/kpi/$id/pdf-preview" });

  const { data: kpi, isLoading, error } = useKPIQuery(id);

  const handleBack = () => {
    nav({ to: "/app/kpi/$id", params: { id } });
  };

  const handlePrint = () => {
    window.print();
  };

  if (isLoading) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex min-h-[400px] items-center justify-center">
            <div className="text-center">
              <div className="mx-auto h-8 w-8 animate-spin rounded-full border-primary border-b-2" />
              <p className="mt-2 text-muted-foreground">ກໍາລັງໂຫຼດ...</p>
            </div>
          </div>
        </Main>
      </>
    );
  }

  if (error || !kpi) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex min-h-[400px] items-center justify-center">
            <div className="text-center">
              <h2 className="mb-2 font-bold text-2xl text-destructive">
                ບໍ່ພົບ KPI
              </h2>
              <p className="mb-4 text-muted-foreground">
                KPI ທີ່ທ່ານຊອກຫາບໍ່ມີຢູ່ ຫຼື ຖືກລຶບໄປແລ້ວ
              </p>
              <Button onClick={handleBack}>
                <ArrowLeftIcon className="mr-2 h-4 w-4" />
                ກັບໄປທີ່ KPI
              </Button>
            </div>
          </div>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header />

      <Main>
        {/* Header Actions - Hidden in print */}
        <div className="mb-6 flex items-center justify-between print:hidden">
          <Button variant="ghost" onClick={handleBack} className="gap-2">
            <ArrowLeftIcon className="h-4 w-4" />
            ກັບໄປທີ່ KPI
          </Button>

          <div className="flex items-center gap-2">
            <Button variant="outline" onClick={handlePrint} className="gap-2">
              <PrinterIcon className="h-4 w-4" />
              ພິມ
            </Button>
          </div>
        </div>

        {/* PDF Preview Content */}
        <KPIPdfPreviewContent kpi={kpi} />
      </Main>
    </>
  );
}
